import { render, staticRenderFns } from "./EstadoFactura.vue?vue&type=template&id=0eb5cef1"
import script from "./EstadoFactura.vue?vue&type=script&lang=js"
export * from "./EstadoFactura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports